import { PageId } from 'constants/pages'

export const enum PageIdStylioCapsule2 {
  AGE_CAPSULE2 = PageId.AGE_CAPSULE2,
  URGE_CAPSULE2 = PageId.URGE_CAPSULE2,
  HAIR_COLOR_CAPSULE2 = PageId.HAIR_COLOR_CAPSULE2,
  EYES_COLOR_CAPSULE2 = PageId.EYES_COLOR_CAPSULE2,
  JEWELRY_CAPSULE2 = PageId.JEWELRY_CAPSULE2,
  BODY_SHAPE_CAPSULE2 = PageId.BODY_SHAPE_CAPSULE2,
  STYLIO_TO_HELP_CAPSULE2 = PageId.STYLIO_TO_HELP_CAPSULE2,
  TALL_CAPSULE2 = PageId.TALL_CAPSULE2,
  WEIGHT_CAPSULE2 = PageId.WEIGHT_CAPSULE2,
  URGE_2_CAPSULE2 = PageId.URGE_2_CAPSULE2,
  SHOPPING_CAPSULE2 = PageId.SHOPPING_CAPSULE2,
  STYLE_MOST_MATTERS_CAPSULE2 = PageId.STYLE_MOST_MATTERS_CAPSULE2,
  FEEL_ABOUT_CAPSULE2 = PageId.FEEL_ABOUT_CAPSULE2,
  PERCENTAGE_CAPSULE2 = PageId.PERCENTAGE_CAPSULE2,
  FAVORITE_COLORS_CAPSULE2 = PageId.FAVORITE_COLORS_CAPSULE2,
  LIKE_OR_DISLIKE_CAPSULE2 = PageId.LIKE_OR_DISLIKE_CAPSULE2,
  LIKE_OR_DISLIKE_11_CAPSULE2 = PageId.LIKE_OR_DISLIKE_11_CAPSULE2,
  LIKE_OR_DISLIKE_12_CAPSULE2 = PageId.LIKE_OR_DISLIKE_12_CAPSULE2,
  LIKE_OR_DISLIKE_13_CAPSULE2 = PageId.LIKE_OR_DISLIKE_13_CAPSULE2,
  LIKE_OR_DISLIKE_14_CAPSULE2 = PageId.LIKE_OR_DISLIKE_14_CAPSULE2,
  LIKE_OR_DISLIKE_15_CAPSULE2 = PageId.LIKE_OR_DISLIKE_15_CAPSULE2,
  LIKE_OR_DISLIKE_16_CAPSULE2 = PageId.LIKE_OR_DISLIKE_16_CAPSULE2,
  LIKE_OR_DISLIKE_17_CAPSULE2 = PageId.LIKE_OR_DISLIKE_17_CAPSULE2,
  LIKE_OR_DISLIKE_18_CAPSULE2 = PageId.LIKE_OR_DISLIKE_18_CAPSULE2,
  LIKE_OR_DISLIKE_19_CAPSULE2 = PageId.LIKE_OR_DISLIKE_19_CAPSULE2,
  STYLES_FEEL_LIKE_YOU_CAPSULE2 = PageId.STYLES_FEEL_LIKE_YOU_CAPSULE2,
  URGE_4_CAPSULE2 = PageId.URGE_4_CAPSULE2,
  BRAND_CAPSULE2 = PageId.BRAND_CAPSULE2,
  FIND_NEW_CLOTHES_CAPSULE2 = PageId.FIND_NEW_CLOTHES_CAPSULE2,
  NOTHING_TO_WEAR_CAPSULE2 = PageId.NOTHING_TO_WEAR_CAPSULE2,
  OLD_CLOTHES_CAPSULE2 = PageId.OLD_CLOTHES_CAPSULE2,
  COMBINE_CLOTHES_CAPSULE2 = PageId.COMBINE_CLOTHES_CAPSULE2,
  OPTIMIZE_BUDGET_CAPSULE2 = PageId.OPTIMIZE_BUDGET_CAPSULE2,
  URGE_3_CAPSULE2 = PageId.URGE_3_CAPSULE2,
  PREPARE_FLOW_CAPSULE2 = PageId.PREPARE_FLOW_CAPSULE2,
  EMAIL_CAPSULE2 = PageId.EMAIL_CAPSULE2,
  EMAIL_CONSENT_CAPSULE2 = PageId.EMAIL_CONSENT_CAPSULE2,
  SUBSCRIPTIONS_CAPSULE2 = PageId.SUBSCRIPTIONS_CAPSULE2,
  CANCEL_OFFER_CAPSULE2 = PageId.CANCEL_OFFER_CAPSULE2,
  SUB_UPSELL_CAPSULE2 = PageId.SUB_UPSELL_CAPSULE2,
  UPSELL_CAPSULE2 = PageId.UPSELL_CAPSULE2,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_CAPSULE2 = PageId.DOWNLOAD_CAPSULE2,
}
